



























import { Component, Vue, Watch } from 'vue-property-decorator';
import SmartBanner from '@/components/core/SmartBanner.vue';
import Welcome from '@/components/welcome/Welcome.vue';
import Teacher from '@/components/teacher/Teacher.vue';
import School from '@/components/school/School.vue';
import Price from '@/components/price/Price.vue';
import Mobile from '@/components/mobile/Mobile.vue';
import Help from '@/components/help/Help.vue';
import About from '@/components/about/About.vue';
import CareersLanding from '@/components/careers/Landing.vue';
// import CareersPosition1 from '@/components/careers/Position1.vue';
// import CareersPosition2 from '@/components/careers/Position2.vue';
// import CareersPosition3 from '@/components/careers/Position3.vue';
// import CareersPosition4 from '@/components/careers/Position4.vue';
// import CareersPHLanding from '@/components/careersph/Landing.vue';
// import CareersPHPosition1 from '@/components/careersph/Position1.vue';
// import CareersPHPosition2 from '@/components/careersph/Position2.vue';
import Terms from '@/components/terms/Terms.vue';
import Privacy from '@/components/privacy/Privacy.vue';

import Bowser from 'bowser';

declare const window: Window;
const bowser = Bowser.getParser(window.navigator.userAgent);

@Component({
  components: {
    SmartBanner,
    Welcome,
    Teacher,
    School,
    Price,
    Mobile,
    Help,
    About,
    CareersLanding,
    // CareersPosition1,
    // CareersPosition2,
    // CareersPosition3,
    // CareersPosition4,
    // CareersPHLanding,
    // CareersPHPosition1,
    // CareersPHPosition2,
    Terms,
    Privacy
  }
})
export default class App extends Vue {
  currentPage = '';

  get browser() {
    return bowser.getBrowserName().toLowerCase();
  }

  mounted() {
    this.getCurrentPage();
  }

  @Watch('$route')
  onRouteChange() {
    this.getCurrentPage();
  }

  getCurrentPage() {
    this.currentPage = this.$route.path;

    if (this.$route.hash) {
      this.$router.push('/' + this.$route.hash.replace('#', ''));
    }
  }
}
